import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from 'react-router-dom';
import { createReactRouterV6Options, getWebInstrumentations, initializeFaro, ReactIntegration, ReactRouterVersion } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { useEffect } from 'react';

export function FaroProvider() {
  useEffect(() => {
    // Initialize Faro only once on the client side
    initializeFaro({
      url: "https://faro-collector-prod-us-east-2.grafana.net/collect/00a1aad4836eca415bf3a93f88489bbc",
      app: {
        name: "Launch OS App",
        version: "2.0.0-beta",
        environment: "production",
      },

      consoleInstrumentation: {
        consoleErrorAsLog: true,
        disabledLevels: [],
      },

      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations({
          captureConsole: true,
        }),

        // Tracing package to get end-to-end visibility for HTTP requests.
        // TODO: Remove if in production
        new TracingInstrumentation(),

        // React integration for React applications.
        new ReactIntegration({
          router: createReactRouterV6Options({
            createRoutesFromChildren,
            matchRoutes,
            Routes,
            useLocation,
            useNavigationType,
          }),
        }),
      ],
    });
  }, []);

  return null; // This component doesn't render anything
}
